// store/balance/balanceInitialState.ts

import { AxeResponseDto, TagResponseDto, TagsQueryParams } from '../../types';

/**
 * @french
 * État initial du slice de balance.
 */
export const tagsInitialState = {
  tagsQueryParams: null as TagsQueryParams | null,
  selectedAxe: undefined as AxeResponseDto | undefined,
  selectedTag: undefined as TagResponseDto | undefined,
};

/**
 * @french
 * Type dérivé de l’état initial.
 */
export type TagsState = typeof tagsInitialState;
